import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../styles/HomePage.css";
import image1 from '../images/steik_2.jpeg';
import image2 from '../images/image2.png';
import image3 from '../images/steik_1.jpg';
import cowImage from '../images/cow_mini.png';
import expressImage from '../images/express_mini.png';
import meetImage from '../images/meet_mini.png';
import steakImage from '../images/steak_mini.png';

const articles = [
  { id: 1, title: 'Рекомендации по приготовлению. Хоспер и гриль', content: 'Чтобы насладится вкусом мраморной говядины, необходимо соблюдать следующие правила приготовления: 1. Всегда правильно размораживайте мясо. Чтобы при размораживании сохранить качество мяса. Очень важно размораживать мясо в холодильнике при температуре +2 +6 С, до полной оттайки, примерно двое суток. (Ни в коем случае в горячей воде или микроволновой печи!!!). Потеря веса при разморозке составляют от 3% до 7% в зависимости от отруба.' },
  { id: 2, title: 'Рекомендации по приготовлению. Cу-вид', content: 'Sous-vide или сувид– методика приготовления пищи, которая в русскоязычной гастрономии пока воспринимается как нечто совершенно новое. Тем не менее, в европейской кухне этот способ набирает все большую популярность, особенно в так называемой молекулярной кухне. Однако в последнее время на рынке появилось множество бытовых приборов, которые сделали возможным использовать этот метод готовки и дома.' },
  // Добавьте больше статей здесь
];

const HomePage = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    fade: true // Добавлен эффект затухания при смене слайдов
  };

  return (
    <div className="home-page-container">
      <Slider {...settings} className="home-page-slider">
        <div className="home-page-slider-img">
          <img src={image1} alt="Slide 1" />
          <div className="home-page-slide-caption">
            <h3>Лучшие стейки</h3>
            <p>Откройте для себя лучшие стейки с нашей мраморной говядиной</p>
          </div>
        </div>
        <div className="home-page-slider-img">
          <img src={image2} alt="Slide 2" />
          <div className="home-page-slide-caption">
            <h3>Свежие продукты</h3>
            <p>Наши продукты всегда свежие и высокого качества</p>
          </div>
        </div>
        <div className="home-page-slider-img">
          <img src={image3} alt="Slide 3" />
          <div className="home-page-slide-caption">
            <h3>Рецепты для гурманов</h3>
            <p>Попробуйте наши эксклюзивные рецепты</p>
          </div>
        </div>
        {/* Добавьте больше слайдов здесь */}
      </Slider>
      <div className="home-page-why-choose-us">
        <h2>ПОЧЕМУ ВЫ ВЫБРАЛИ НАС</h2>
        <p>ВСЕГО ЧЕТЫРЕ ФАКТА</p>
        <div className="home-page-features">
          <div className="home-page-feature">
            <img src={cowImage} alt="Экологичность" />
            <h3>Экологичность</h3>
            <p>Наши бычки выращиваются в экологически чистой зоне, при сбалансированном и натуральном питании</p>
          </div>
          <div className="home-page-feature">
            <img src={meetImage} alt="Мраморное мясо" />
            <h3>Мраморное мясо</h3>
            <p>Приобретая нашу продукцию, Вы знаете что Ваши блюда будут как всегда безупречны и невероятно вкусны!</p>
          </div>
          <div className="home-page-feature">
            <img src={expressImage} alt="Покупка и доставка" />
            <h3>Покупка и доставка</h3>
            <p>Простота покупки на нашем сайте и удобная доставка, принесут Вам удовольствие от готовки кулинарных шедевров!</p>
          </div>
          <div className="home-page-feature">
            <img src={steakImage}  />
            <h3>100% результат!</h3>
            <p>Чтобы приготовить сочный, вкуснейший стейк, Вам не нужно быть опытным поваром! Достаточно продукции MB4!</p>
          </div>
        </div>
      </div>
      <div className="home-page-article-container">
        {articles.map((article) => (
          <div key={article.id} className="home-page-article">
            <h2 className="home-page-zagolovok">{article.title}</h2>
            <p className="home-page-text">{article.content}</p>
            <a href={`/articles/${article.id}`} className="home-page-navigation">Читать дальше</a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HomePage;
